import { render, staticRenderFns } from "./VisualizarVideo.vue?vue&type=template&id=7b6112a0&"
import script from "./VisualizarVideo.vue?vue&type=script&lang=js&"
export * from "./VisualizarVideo.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports